import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { PostAlert } from "./AlertActions";
import { Logout } from "./LoginActions";
import { loadActiveADTrees } from "../state/activeDocumentsSlice";
import { loadADDocuments } from "../state/activeDocumentListSlice";
export function GetADTree(completed, dispatch) {
  axios.get(`${Globals.baseUrl}/ActiveDocument/GetADTree/${completed}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      if (dispatch !== void 0) {
        dispatch(loadActiveADTrees(res.data));
      }
      dispatcher.dispatch({
        actionType: actionTypes.ADGetADTree,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetBPPermissions(bpId) {
  let bp = bpId;
  axios.get(`${Globals.baseUrl}/RolePermission/GetBPPermission/${bpId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.BPGetPermission,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetBP(bpId, column, order, showCompleted, offset, dispatch) {
  console.log(showCompleted);
  console.log(offset);
  axios.get(
    `${Globals.baseUrl}/ActiveDocument/GetADBP/${bpId}/${column}/${order}/${showCompleted}/${offset}`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.ADGetStep,
        Result: res.data
      });
      if (dispatch !== void 0) {
        dispatch(loadADDocuments(res.data));
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetADStep(id, bpId, column, order, offset, showCompleted, dispatch) {
  axios.get(
    `${Globals.baseUrl}/ActiveDocument/GetADStep/${id}/${bpId}/${column}/${order}/${showCompleted}/${offset}`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      result.request = {
        stepId: id,
        bpId,
        sortCol: column,
        sortOrder: order,
        offset,
        showCompleted
      };
      dispatcher.dispatch({
        actionType: actionTypes.ADGetStep,
        Result: result
      });
      if (dispatch !== void 0) {
        dispatch(loadADDocuments(res.data));
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function ExportActiveDocuments(query, formatDocumentIdAsTrinDocsLink, currentUrl, downloadName, formTypeId, params) {
  console.log(params);
  axios.post(
    `${Globals.baseUrl}/ActiveDocument/ExportActiveDocuments`,
    {
      query,
      formatDocumentIdAsTrinDocsLink,
      currentUrl,
      formTypeId,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      },
      responseType: "blob"
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.ADExport,
        Result: res.data
      });
      var link = document.createElement("a");
      link.setAttribute("download", "");
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = downloadName;
      document.body.appendChild(link);
      link.click();
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function ExportActiveDocuments2(query, formatDocumentIdAsLink, downloadName, formTypeId, callback) {
  console.log(query);
  axios.post(
    `${Globals.baseUrl}/ActiveDocument/ExportActiveDocuments2`,
    {
      query,
      formatDocumentIdAsTrinDocsLink: formatDocumentIdAsLink,
      downloadName,
      formTypeId
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      },
      responseType: "blob"
    }
  ).then((res) => {
    if (res.status === 200) {
      var link = document.createElement("a");
      link.setAttribute("download", "");
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = downloadName;
      document.body.appendChild(link);
      link.click();
      callback();
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateUserHeaderSettings(formTypeId, settings) {
  axios.post(
    `${Globals.baseUrl}/ActiveDocument/UpdateUserHeaderSettings`,
    {
      formTypeId,
      settings
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      PostAlert("success", "User settings updated");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
